// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEoyPlanReconciliationPropertyDto
 */
export interface IEoyPlanReconciliationPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IEoyPlanReconciliationPropertyDto
     */
    eoy_plan_reconciliation?: IEoyPlanReconciliationPropertyDtoEoyPlanReconciliationEnum;
    /**
     * 
     * @type {string}
     * @memberof IEoyPlanReconciliationPropertyDto
     */
    eoy_plan_reconciliation_state?: IEoyPlanReconciliationPropertyDtoEoyPlanReconciliationStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IEoyPlanReconciliationPropertyDtoEoyPlanReconciliationEnum {
    NONE = 'NONE',
    BANK_ACCOUNT = 'BANK_ACCOUNT',
    EMPLOYER = 'EMPLOYER',
    PARTNER = 'PARTNER'
}
/**
* @export
* @enum {string}
*/
export enum IEoyPlanReconciliationPropertyDtoEoyPlanReconciliationStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IEoyPlanReconciliationPropertyDto interface.
 */
export function instanceOfIEoyPlanReconciliationPropertyDto(value: object): value is IEoyPlanReconciliationPropertyDto {
    return true;
}

export function IEoyPlanReconciliationPropertyDtoFromJSON(json: any): IEoyPlanReconciliationPropertyDto {
    return IEoyPlanReconciliationPropertyDtoFromJSONTyped(json, false);
}

export function IEoyPlanReconciliationPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEoyPlanReconciliationPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'eoy_plan_reconciliation': json['eoy_plan_reconciliation'] == null ? undefined : json['eoy_plan_reconciliation'],
        'eoy_plan_reconciliation_state': json['eoy_plan_reconciliation_state'] == null ? undefined : json['eoy_plan_reconciliation_state'],
    };
}

export function IEoyPlanReconciliationPropertyDtoToJSON(json: any): IEoyPlanReconciliationPropertyDto {
    return IEoyPlanReconciliationPropertyDtoToJSONTyped(json, false);
}

export function IEoyPlanReconciliationPropertyDtoToJSONTyped(value?: IEoyPlanReconciliationPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eoy_plan_reconciliation': value['eoy_plan_reconciliation'],
        'eoy_plan_reconciliation_state': value['eoy_plan_reconciliation_state'],
    };
}

